import { render } from "./tipcard.vue?vue&type=template&id=8b2e2c9c&scoped=true"
import script from "./tipcard.vue?vue&type=script&lang=js"
export * from "./tipcard.vue?vue&type=script&lang=js"

import "./tipcard.vue?vue&type=style&index=0&id=8b2e2c9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8b2e2c9c"

export default script